const shared = {
    "54E1": "54E1",
    "54E5": "54E5",
    // "540": "540",
    "195": "195",
    "725": "725",
    "390": "390",
    "204": "204",
    "260": "260",
    "400": "400",
    "465": "465",
    "1200": "1200",
    "600": "600",
    "1_9": "1:9",
    "1_15": "1:15",
    "1_4,5_2x1_9": "1:4,5 2x1:9",
    "1_12": "1:12",
    "R260MN": "R260Mn",
    "R370LHT": "R370LHT",
    "R350HT": "R350HT",
    "LANGUAGE_NL": "Nederlands",
    "LANGUAGE_EN": "English",
    "LANGUAGE_DE": "Deutsch",
};
const nl = {
    "EXACT_MATCH": "Exacte match op",
    "tekeningnummer": "Tekeningnummer",
    "key": "Identificatiecode",
    "geocode": "Geocode",
    "MN": "Mangaanstaal",
    "HT": "Hoogwaardig staal",
    "CURRENCY_LOCALE": "nl-NL",
    "ANGLE": "Hoek",
    "LEFT": "Links",
    "RIGHT": "Rechts",
    "SYMETRIC": "Symmetrisch",
    "NORMAL_SWITCH": "Gewoon Wissel",
    "NORMAL_SWITCH:ANGLE=LEFT": "Gewoon Wissel Links",
    "NORMAL_SWITCH:ANGLE=RIGHT": "Gewoon Wissel Rechts",
    "SYMMETRIC_SWITCH": "Symmetrisch Wissel",
    "INTERSECTION_SWITCH": "Kruiswissel",
    "ENGLISH_SWITCH": "Engels Wissel",
    "HALF_ENGLISH_SWITCH": "Half Engels Wissel",
    "CONCRETE": "Beton",
    "WOOD": "Hout",
    "WOOD_DESCRIPTION": "Wisselcomponenten op houten dwarsliggers zijn niet te kiezen in de configurator. Neem contact met ons op voor een passende oplossing.",
    "CONTACT_US": "Contact opnemen",
    "CONTINUE_CONFIGURATION": "Configuratie voortzetten",
    "CONTINUE_CONFIGURATION_DESCRIPTION": "We hebben een eerdere configuratie gevonden. Wilt u deze verder afmaken of een nieuwe configuratie starten?",
    "CONFIGURE_NEW": "Nieuwe configuratie",
    "CONFIGURE_EDIT": "Verder gaan",
    "NOT_POSSIBLE_DESCRIPTION": "Deze optie is niet mogelijk in combinatie met (een van) de voorgaande keuzes.",
    "NOT_POSSIBLE_CHANGE_TO": ({ tab, values }) => { const v = values.split("||"); const list = v.length > 1 ? v.slice(0, -1).join(", ") + " of " + v.at(-1) : v[0]; return `Deze optie is niet mogelijk in combinatie met het huidige ${tab.toLowerCase()}. Verander het ${tab.toLowerCase()} naar ${list} om deze optie te selecteren.`; },
    "PRODUCT_NOT_POSSIBLE_CONTACT_US": "Dit product is niet mogelijk in de huidige configuratie. Neem contact met ons op voor meer informatie.",
    "GO_TO_TAB": ({ tab }) => `Ga naar de keuze: ${tab}`,
    "PRODUCT_DETAILS_TITLE": "Product informatie",
    "NEXT_STEP": "Volgende stap",
    "halveTongbewegingen": "Halve Tongbewegingen",
    "halveTongbeweging": "Halve Tongbeweging",
    "puntstukken": "Puntstukken",
    "puntstuk": "Puntstuk",
    "kruisstukken": "Kruisstukken",
    "kruisstuk": "Kruisstuk",
    "strijkregels": "Strijkregels",
    "strijkregel": "Strijkregel",
    "onderlegplaten": "Onderlegplaten",
    "onderlegplaat": "Onderlegplaat",
    "rugplatenEnStoelen": "Rugplaten en stoelen",
    "rugplaatEnStoel": "Rugplaat en stoel",
    "bevestigingsmaterialen": "Bevestigingsmiddelen",
    "bevestigingsmiddelen": "Bevestigingsmiddelen",
    "bevestigingsmiddel": "Bevestigingsmiddel",
    "wisselstellers": "Wisselstellers",
    "wisselsteller": "Wisselsteller",
    "smeerlozeConstructies": "Smeerloze constructies",
    "smeerlozeConstructie": "Smeerloze constructie",
    "nrglassen": "NRG-lassen",
    "nrglas": "NRG-las",
    "VARIANT_CHANGED_TITLE": "Een productvariant is gewijzigd",
    "VARIANT_CHANGED_DESCRIPTION": ({ cat }) => `De variant van ${cat} is gewijzigd`,
    "FROM": "Van",
    "TO": "Naar",
    "BEKIJK_PRODUCT": "Bekijk product",
    "ADD_PRODUCTS": "Voeg meer producten toe",
    "ADD_PRODUCTS_DESCRIPTION": "Je kunt extra producten toevoegen aan je lijst, zoals bevestigingsmaterialen.",
    "ok": "Begrepen",
    "NOT_AVAILABLE_SHORT": "niet beschikbaar",
    "WILL_OVERRIDE_CONFIGURATION": "Hiermee wordt de huidige configuratie overschreven.",
    "NO_CANCEL": "Nee, annuleren",
    "YES_APPLY": "Ja, toepassen",
    "YES_CONTINUE": "Ja, doorgaan",
    "NO_RESULTS_FOUND": "Geen resultaten gevonden",
    "RECENT_SEARCHES": "Recent bekeken",
    "NO_RECENT_SEARCHES": "Geen recent bekeken wissels",
    "REMOVE_FROM_RECENT": "Verwijderen uit recent bekeken",
    "SWITCH_TYPE": "Wisseltype",
    "SLEEPER_TYPE": "Dwarsligger",
    "ANGLE_RATIO": "Hoekverhouding",
    "RAIL_PROFILE": "Spoorstaafprofiel",
    "RADIUS": "Boogstraal",
    "GEOCODE": "Geocode",
    "LUBRICANT_FREE_CONSTRUCTION": "Smeerloze Constructie",
    "AFSCHRIJVINGSGROEP_TODO": "Afschrijvingsgroep",
    "CLASSIFICATION": "Classificatie",
    "PLACEMENT_DATE": "Plaatsingsdatum",
    "DRAWING_NUMBER": "Tekeningnummer",
    "SELECTED_SWITCH_CONFIGURATION": "De gekozen wissel configuratie",
    "NOT_AVAILABLE": "Dit wissel/kruising is momenteel niet beschikbaar in de configurator.",
    "CROSSING": "Kruising",
    "SWITCH": "Wissel",
    "APPLY_THIS": ({ type }) => `Wil je deze ${type} toepassen?`,
    "NOTIFY_PRORAIL_ISSUE": "Geef feedback",
    "DESCRIBE_ERROR_HERE": "Omschrijf hier de fout",
    "CANCEL_BUTTON": "Annuleren",
    "SEND_EMAIL": "E-mail sturen",
    "PARTS_LIST_TITLE": "Mijn lijst",
    "CONFIGURATION": "Configuratie:",
    "SEARCH_RESULTS_FOR": ({ term }) => `Zoekresultaten voor "${term}"`,
    "PDF_SWITCH_PARTS_CONFIGURATOR": "Wisseldelen configurator",
    "VOESTALPINE_RAILWAY_SYSTEMS": "voestalpine Railway Systems",
    "VOESTALPINE_WEBSITE": "www.voestalpine.com/railway-systems",
    "ARTICLE_NUMBER": "Artikelnummer",
    "RELATED_PARTS": "Gerelateerde producten",
    "TAB_SPECIFICATIONS": "Specificaties",
    "CHARACTERISTIC": "Kenmerk",
    "SPECIFICATION": "Specificatie",
    "NO_SPECIFICATIONS_AVAILABLE": "Geen specificaties beschikbaar",
    "PDF_FILE_NAME": "Configuratie wissel",
    "CONFIGURATION_WILL_BE_DELETED": "Hiermee wordt de gehele configuratie verwijderd.",
    "CONFIGURATION_NUMBER": "[Configuratienummer]",
    "CONFIRM_DELETE": "Weet je het zeker?",
    "NO_DELETE": "Nee, annuleren",
    "YES_RESET": "Ja, reset",
    "YES_DELETE": "Ja, verwijder",
    "REMOVE_ARTICLE": "Wil je dit artikel verwijderen uit de configuratie?",
    "RESET_BUTTON": "Reset",
    "PARTS_LIST_BTN": "Lijst",
    "INCOMPLETE_INFO_TITLE": "Onvolledige informatie",
    "ANSWER_ALL_QUESTIONS": "Beantwoord alle vragen om het product te kunnen bekijken.",
    "PARTS_LIST_UPDATED": "Stuklijst is bijgewerkt",
    "EXC_VAT": "excl.btw",
    "SAVE_CONFIGURATION": "Samenstelling opslaan",
    "PARTS_COMPOSITION": "Wisseldelen samenstelling:",
    "DESCRIPTION": "Omschrijving",
    "QUANTITY": "Hoeveelheid",
    "PRODUCT_CODE": "Productcode",
    "TOTAL_AMOUNT_EXC_VAT": "Totaal bedrag excl. btw",
    "TOTAL": "Totaal",
    "NO_PRODUCTS_SELECTED": "Geen producten geselecteerd",
    "PLACE_ORDER": "Bestelling plaatsen",
    "TECHNICAL_DRAWING": "Technische tekening en specificatie",
    "TECHNICAL_DRAWINGS": "Technische tekeningen en specificaties",
    "TOTAL_AMOUNT": "Totaalbedrag",
    "NO_PRODUCTS_FOUND": "Geen producten gevonden",
    "TAB_DOCUMENTS": "Documenten",
    "SEARCH_IN_PRORAIL_DATABASE": "Zoek in ProRail database",
    "PRORAIL_CHOICE": "ProRail keuze",
    "TAB_PRODUCT": "Product",
    "TAB_QUESTIONS": "Vragen",
    "OUT_OF_STOCK": "Niet op voorraad",
    "QUESTIONS_LABEL": "Opties",
    "REMOVE": "Verwijderen",
    "UPDATE": "Bijwerken",
    "ADD": "Toevoegen",
    "NEXT": "Volgende",
    "IN_STOCK": "Op voorraad, direct leverbaar",
    "IN_STOCK_CACHE": "Op voorraad, binnen x dagen leverbaar",
    "CUSTOM_VALUE": "Aangepaste waarde",
    "CLOSE": "Sluiten",
    "Q_MATERIAL": "Materiaal",
    "Q_SWITCH_HEATING": "Wisselverwarming",
    "Q_SWITCH_OPERATION": "Wisselbediening",
    "Q_CHAIRS_AND_TAPE_END": "Stoelen en tapeind",
    "Q_LEFT_RIGHT": "Positie tongbeweging",
    "Q_LUBRICANT_FREE_CONSTRUCTION": "Lubrication free turnout system",
    "Q_POINT_BLADE_MATERIAL": "Puntstuk materiaal",
    "Q_CROSS_BLADE_MATERIAL": "Kruisstuk materiaal",
    "Q_STRIKE_RULE_MATERIAL": "Strijkregel materiaal",
    "L_LEG_LEFT": "Linker been",
    "L_LEG_RIGHT": "Rechter been",
    "L_LEG_LEFT_INSIDE": "Linksbinnen",
    "L_LEG_LEFT_OUTSIDE": "Linksbuiten",
    "L_LEG_RIGHT_INSIDE": "Rechtsbinnen",
    "L_LEG_RIGHT_OUTSIDE": "Rechtsbuiten",
    "L_HEATING_PREPARED": "Wisselverwarming voorbereid",
    "L_HEATING_CENTRAL": "Centrale buisverwarming",
    "L_LOW": "Laag",
    "L_HIGH": "Hoog",
    "L_CHAIRS_NONE": "Zonder",
    "L_CHAIRS_CONCRETE_SLEEPERS": "Op betonnen liggers",
    "L_CHAIRS_WOOD_SLEEPERS": "Op houten liggers",
    "L_CHAIRS_CONCRETE_SLEEPERS_TAPE": "Op betonnen liggers en tapeind voor NSE-2, VHO, EHO en LPM",
    "L_CHAIRS_WOOD_SLEEPERS_TAPE": "Op houten liggers en tapeind voor NSE-2, VHO, EHO en LPM",
    "L_CHAIRS_SLIDING_EBI": "Glijplaat en glijstoel voor toepassing met EBI",
    "L_CHAIRS_SLIDING_EBI_TAPE": "Glijplaat en glijstoel voor toepassing met EBI en tapeind",
    "L_CHAIRS_TAPE": "Tapeind voor NSE-2, VHO, EHO en LPM",
    // "L_CHAIRS_HEATING_CONCRETE_SLEEPERS_TAPE": "Centrale Buisverwarming op betonnen liggers en tapeind voor NSE, VHO, EHO en LPM",
    "L_CHAIRS_TAPE_EBI": "Tapeind voor EBI",
    // "L_CHAIRS_HEATING_SLIDING_EBI_TAPE": "Centrale Buisverwarming Glijplaat en glijstoel voor toepassing met EBI en tapeind",
    "L_OPERATION_EBI": "EBI-Switch",
    "L_OPERATION_OTHER": "Overige",
    "L_LUBRICANT_FREE_AUSTROROLL": "Austroroll",
    "L_LUBRICANT_FREE_DELTA_SWITCH": "Delta-Switch",
    "L_LUBRICANT_FREE_EKOS": "EKOS/Zonder",
    "LOADING": "Aan het laden...",
    "SEARCH_RESULTS": "Zoek resultaten",
    "SEARCH_RESULTS_DISCLAIMER": "De database van ProRail kan onjuistheden bevatten of incompleet zijn. Controleer altijd of de gegevens correct zijn.",
    "SEARCH_INPUT": "Zoek input",
    "SEARCH": "Zoeken",
    "MAT_DESC_0": "Kraagbout NS vlak en zuiver rond onder de kop",
    "MAT_DESC_1": "Klembout M22 x 70 mm met handelsmoer",
    "MAT_DESC_2": "Vierkantbout M22 x 80 mm met moer",
    "MAT_DESC_3": "Klemplaat",
    "MAT_DESC_4": "Veerring, gewelfd",
    "MAT_DESC_5": "Veerring",
    "MAT_DESC_6": "Vulplaat",
    "MAT_DESC_7": "Spoorplaatje SSp 4",
    "MAT_DESC_8": "Sluitring 23-St-DIN-6916",
    "MAT_DESC_9": "Klemplaat afgeschuind",
    "MAT_DESC_10": "Stek abnormale klemplaten",
    "MAT_DESC_11": "Vulplaat tussen strijkregel en stoel voor strijkregel",
    "MAT_DESC_12": "Vulplaat tussen strijkregel en stoel",
    "MAT_DESC_13": "Stel vlakke rugplaten onder tongbeweging 54E1 1:9",
    "MAT_DESC_14": "Stoel voor strijkregel 54E1",
    "MAT_DESC_15": "Gegoten vlakke rugplaat 54E1",
    "MAT_DESC_16": "Vlakke lasrugplaat 54E1 voor lijmlas",
    "MAT_DESC_17": "Stel vlakke rugplaten",
    "MAT_DESC_18": "Vlakke rugplaat 54E1 gegoten",
    "MAT_DESC_19": "Vlakke rugplaat 54E1 schuin ingekort Links",
    "MAT_DESC_20": "Stoel 54E1 voor strijkregel, Links",
    "MAT_DESC_21": "Stoel 54E1 voor strijkregel, Rechts",
    "MAT_DESC_22": "Rugplaat (E1) evenwijdig ingekort L",
    "MAT_DESC_23": "Rugplaat (E2) evenwijdig ingekort L",
    "MAT_DESC_24": "Set rugplaten I en VII ter plaatse van kruisstuk",
    "MAT_DESC_25": "Vlakke lasrugplaat, ingekort links",
    "MAT_DESC_26": "Vlakke lasrugplaat, ingekort rechts",
    "MAT_DESC_27": "Set rugplaten I, II, IX en X ter plaatse van kruisstuk",
    "MAT_DESC_28": "Set rugplaten XI, XII, XIX en XX ter plaatse van kruisstuk",
    "MAT_DESC_29": "Onderlegplaat",
    "MAT_DESC_30": "Onderlegplaat onder rugplaat",
    "MAT_DESC_31": "Onderlegplaat onder glijstoel",
    "MAT_DESC_32": "Set onderlegplaten",
    "MAT_DESC_33": "Set onderlegplaten onder en achter tongbeweging",
    "MAT_DESC_34": "Onderlegplaat onder lasrugplaat",
    "MAT_DESC_35": "Set onderlegplaten onder glijstoel",
    "MAT_DESC_36": "Set onderlegplaten onder rugplaat 54E1",
    "MAT_DESC_37": "Onderlegplaat onder lasrugplaat 18-027",
    "MAT_DESC_38": "Onderlegplaat onder stoel voor strijkregel",
    "MAT_DESC_39": "Onderlegplaat onder kruisstuk 1:4,5",
    "MAT_DESC_40": "Onderlegplaat onder 65-245",
    "MAT_DESC_41": "Onderlegplaat voor vlakke rugplaat E1/E2",
    "MAT_DESC_42": "Onderlegplaat onder schuin ingekorte glijstoel",
    "MAT_DESC_43": "Set kurkrubberplaten (10) FC897",
    "MAT_DESC_44": "Onderlegplaat onder vlakke rugplaat",
    "MAT_DESC_45": "Onderlegplaat onder evenwijdig ingekorte vlakke lasrugplaat 54E1, 15-203/204",
    "MAT_DESC_46": "Set onderlegplaten onder rugplaten I t/m X",
    "MAT_DESC_47": "Set onderlegplaten onder rugplaten XI t/m XX",
    "SMEERLOOS_DESC_0": "Gereedschapkoffer DeltaSwitch",
    "SMEERLOOS_DESC_1": "Onderdelenset,v montage DeltaSwitch",
    "SMEERLOOS_DESC_2": "DeltaSwitch, hoog tongprofiel",
    "WISSELSTELLER_DESC_0": "Wisselsteller WBN, NSE-S, Links",
    "WISSELSTELLER_DESC_1": "Wisselsteller WBN, NSE-S, Rechts",
    "WISSELSTELLER_DESC_2": "Wisselsteller WBN, NSE-S, HL, Links",
    "WISSELSTELLER_DESC_3": "Wisselsteller WBN, NSE-S, HL, Rechts",
    "WISSELSTELLER_DESC_4": "Wisselsteller WBN, NSE, Links",
    "WISSELSTELLER_DESC_5": "Wisselsteller WBN, NSE, Rechts",
    "WISSELSTELLER_DIRECTION_0": "Links",
    "WISSELSTELLER_DIRECTION_1": "Rechts",
    "Q_SWITCH_ACTUATOR_DIRECTION": "Geef de wisselsteller positie aan",
    "DROPDOWN_EMPTY": "Geen resultaten",
    "URL_PREFIX": "nl_NL",
    "SELECT_LANGUAGE": "Selecteer taal",
    "LOGIN_MESSAGE": "Login/Registreer om de prijs en levertijd te zien.",
    "PRORAIL_ANSWER": ({ term }) => `Vooraf ingevulde ProRail-antwoord: ${term}`,
    "PRORAIL_ANSWER_UNKNOWN": "Geen aanbevolen waarde beschikbaar in de ProRail-database",
    "CATEGORY": "Categorie",
    "NEXT_BUTTON": "Verder",
    "PREV_BUTTON": "Terug",
    "FINISH_BUTTON": "Afronden",
    "PLACING_ORDER": "Bestelling plaatsen",
    "PLEASE_WAIT_WHILE_WE_PLACE_YOUR_ORDER": "Even geduld terwijl we uw bestelling plaatsen...",
    "PLEASE_WAIT_WHILE_WE_DOWNLOAD_YOUR_PDF": "Even geduld terwijl we uw PDF opmaken...",
    "SHARE_CONFIGURATION": "Deel uw configuratie",
    "COPY": "Kopieer",
    "COPIED": "Gekopieerd!",
    "COMPLETE_YOUR_CONFIGURATION": "Maak je configuratie compleet",
    "DOWNLOAD_PDF": "Download PDF",
    "SELECT_ANOTHER_PART": "Nog een wisselonderdeel selecteren",
    "SELECT_A_PART": "Een wisselonderdeel selecteren",
    "EXTRA_SERVICES": "Extra diensten",
    "MOBILE_TRACK_SERVICE": "Mobiele Baan Service",
    "MOBILE_TRACK_SERVICE_DESCRIPTION": "We zullen contact opnemen met een passende aanbieding voor ondersteuning van de Mobiele Baan Service van voestalpine Turnout Technology Netherlands B.V.",
    "RETURN_OLD_PRODUCT": "Oud product retourneren?",
    "RETURN_OLD_PRODUCT_DESCRIPTION": "Wij verzorgen de inname en circulaire verwerking van uw vervangen spoormaterialen conform de geldende milieueisen en nemen contact met u op voor de logistieke afhandeling.",
    "MY_OVERVIEW": "Mijn overzicht",
    "SUBTOTAL": ({ count }) => `Subtotaal (${count} items)`,
    "NEED_HELP": "Hulp nodig?",
    "NEED_HELP_DESCRIPTION": "Wij staan klaar om uw specificaties te valideren.",
    "ONDERLEGSET_WARNING_TITLE": "Let op: Je verwijdert een verplicht veiligheidsonderdeel",
    "ONDERLEGSET_WARNING_BODY_1": "Bij dit asset horen verplichte onderlegplaten volgens de geldende ProRail-richtlijnen (SPC/BID). Deze onderdelen maken integraal deel uit van de voorgeschreven veiligheids- en levensduurprestatie van het product.",
    "ONDERLEGSET_WARNING_BODY_2": "Het niet vervangen of toepassen van deze onderlegplaten kan de levensduur en werking van het nieuwe product negatief beïnvloeden.",
    "ONDERLEGSET_WARNING_CHECKBOX": "Ik verklaar dat ik de veiligheidsinformatie heb gelezen en begrip.",
    "KEEP_PRODUCT": "Behoud product",
    "ONDERLEG_NOTE": "Bij dit asset horen verplichte onderlegplaten volgens de geldende ProRail‑richtlijnen (SPC/BID).",
    "PRODUCT_ADDED": "Product toegevoegd",
    "CONTINUE_CONFIGURING": "Verder met configureren",
    "NRG_LAS_CONFIGURATOR_TITLE": "NRG-las configurator",
    "NRG_LAS_CONFIGURATOR_MESSAGE": "De NRG-las kan geconfigureerd worden in onze online configurator. Wil je de configurator openen in een nieuw tabblad?",
    "R260MN_WELDED": "Mangaanstaal met aangelaste benen R260Mn",
};
const en = {
    "EXACT_MATCH": "Exact match on",
    "tekeningnummer": "Drawing number",
    "key": "Key",
    "geocode": "Geocode",
    "MN": "Manganese Steel",
    "HT": "High-Quality Steel",
    "CURRENCY_LOCALE": "en-US",
    "ANGLE": "Angle",
    "LEFT": "Left",
    "RIGHT": "Right",
    "SYMETRIC": "Symmetric",
    "NORMAL_SWITCH": "Single Turnout",
    "NORMAL_SWITCH:ANGLE=LEFT": "Single Turnout Left",
    "NORMAL_SWITCH:ANGLE=RIGHT": "Single Turnout Right",
    "SYMMETRIC_SWITCH": "Single turnout",
    "INTERSECTION_SWITCH": "Double Cross-over",
    "ENGLISH_SWITCH": "Diamond Crossing with slips",
    "HALF_ENGLISH_SWITCH": "Diamond Crossing with a single slip",
    "CONCRETE": "Concrete",
    "WOOD": "Wood",
    "WOOD_DESCRIPTION": "Turnouts with Wooden sleepers are currently not available in the configurator. Please contact us if needed.",
    "CONTACT_US": "Contact us",
    "CONTINUE_CONFIGURATION": "Continue configuration",
    "CONTINUE_CONFIGURATION_DESCRIPTION": "We found a previous configuration. Would you like to continue it or start a new configuration?",
    "CONFIGURE_NEW": "New configuration",
    "CONFIGURE_EDIT": "Continue",
    "NOT_POSSIBLE_DESCRIPTION": "This option is not possible in combination with the previous choice(s).",
    "NOT_POSSIBLE_CHANGE_TO": ({ tab, values }) => { const v = values.split("||"); const list = v.length > 1 ? v.slice(0, -1).join(", ") + " or " + v.at(-1) : v[0]; return `This option is not possible with the current ${tab.toLowerCase()}. Change the ${tab.toLowerCase()} to ${list} to select this option.`; },
    "PRODUCT_NOT_POSSIBLE_CONTACT_US": "This product is not possible in the current configuration. Please contact us for more information.",
    "GO_TO_TAB": ({ tab }) => `Go to choice: ${tab}`,
    "PRODUCT_DETAILS_TITLE": "Product information",
    "NEXT_STEP": "Next step",
    "halveTongbewegingen": "Half-set of switches",
    "halveTongbeweging": "Half-set of switches",
    "puntstukken": "Frogs",
    "puntstuk": "Frog",
    "kruisstukken": "Obtuse Crossing",
    "kruisstuk": "Obtuse Crossing",
    "strijkregels": "Check Rails",
    "strijkregel": "Check Rail",
    "onderlegplaten": "Baseplates",
    "onderlegplaat": "Baseplate",
    "rugplatenEnStoelen": "Base plates and Slide Plates",
    "rugplaatEnStoel": "Base plate and Slide Plate",
    "bevestigingsmaterialen": "Fastening materials",
    "bevestigingsmiddelen": "Fastening materials",
    "bevestigingsmiddel": "Fastening material",
    "wisselstellers": "Point machines",
    "wisselsteller": "Point machine",
    "smeerlozeConstructies": "Rollersystems",
    "smeerlozeConstructie": "Rollersystem",
    "nrglassen": "Insulated Block Joints",
    "nrglas": "Insulated Block Joint",
    "VARIANT_CHANGED_TITLE": "A product variant has changed",
    "VARIANT_CHANGED_DESCRIPTION": ({ cat }) => `The variant of ${cat} has changed`,
    "FROM": "From",
    "TO": "To",
    "BEKIJK_PRODUCT": "View product",
    "ok": "Understood",
    "ADD_PRODUCTS": "Add more products",
    "ADD_PRODUCTS_DESCRIPTION": "You can add extra products to your list, such as fastening materials.",
    "NOT_AVAILABLE_SHORT": "not available",
    "WILL_OVERRIDE_CONFIGURATION": "This will overwrite the current configuration.",
    "NO_CANCEL": "No, cancel",
    "YES_APPLY": "Yes, apply",
    "YES_CONTINUE": "Yes, continue",
    "NO_RESULTS_FOUND": "No results found",
    "RECENT_SEARCHES": "Recently viewed",
    "NO_RECENT_SEARCHES": "No recently viewed turnouts",
    "REMOVE_FROM_RECENT": "Remove from recently viewed",
    "SWITCH_TYPE": "Turnout type",
    "SLEEPER_TYPE": "Sleeper Type",
    "ANGLE_RATIO": "Angle Ratio",
    "RAIL_PROFILE": "Rail Profile",
    "GEOCODE": "Geocode",
    "RADIUS": "Radius",
    "LUBRICANT_FREE_CONSTRUCTION": "Turnout Flangeway Clearance Device",
    "AFSCHRIJVINGSGROEP_TODO": "Depreciation group",
    "CLASSIFICATION": "Classification",
    "PLACEMENT_DATE": "Placement Date",
    "DRAWING_NUMBER": "Drawing Number",
    "SELECTED_SWITCH_CONFIGURATION": "Selected turnout configuration",
    "NOT_AVAILABLE": "This Turnout is not available in the configurator.",
    "CROSSING": "crossing",
    "SWITCH": "Turnout",
    "APPLY_THIS": ({ type }) => `Do you want to apply this ${type}?`,
    "NOTIFY_PRORAIL_ISSUE": "Give feedback",
    "DESCRIBE_ERROR_HERE": "Describe the issue here",
    "CANCEL_BUTTON": "Cancel",
    "SEND_EMAIL": "Send email",
    "PARTS_LIST_TITLE": "My list",
    "CONFIGURATION": "Configuration:",
    "SEARCH_RESULTS_FOR": ({ term }) => `Search results for "${term}"`,
    "PDF_SWITCH_PARTS_CONFIGURATOR": "Turnout Spare Parts Configurator",
    "VOESTALPINE_RAILWAY_SYSTEMS": "voestalpine Railway Systems",
    "VOESTALPINE_WEBSITE": "www.voestalpine.com/railway-systems",
    "ARTICLE_NUMBER": "Article number",
    "RELATED_PARTS": "Related products",
    "TAB_SPECIFICATIONS": "Specifications",
    "CHARACTERISTIC": "Characteristic",
    "SPECIFICATION": "Specification",
    "NO_SPECIFICATIONS_AVAILABLE": "No specifications available",
    "PDF_FILE_NAME": "Configuration Turnout",
    "CONFIGURATION_WILL_BE_DELETED": "This will delete the entire configuration.",
    "CONFIGURATION_NUMBER": "[Configuration number]",
    "CONFIRM_DELETE": "Are you sure?",
    "NO_DELETE": "No, cancel",
    "YES_RESET": "Yes, reset",
    "YES_DELETE": "Yes, delete",
    "REMOVE_ARTICLE": "Do you want to remove this article from the configuration?",
    "RESET_BUTTON": "Reset",
    "PARTS_LIST_BTN": "Parts List",
    "INCOMPLETE_INFO_TITLE": "Incomplete information",
    "ANSWER_ALL_QUESTIONS": "Complete the selection to view the product.",
    "PARTS_LIST_UPDATED": "Parts list has been updated",
    "EXC_VAT": "excl. VAT",
    "SAVE_CONFIGURATION": "Save configuration",
    "PARTS_COMPOSITION": "Turnout parts composition:",
    "DESCRIPTION": "Description",
    "QUANTITY": "Quantity",
    "PRODUCT_CODE": "Product code",
    "TOTAL_AMOUNT_EXC_VAT": "Total amount excl. VAT",
    "TOTAL": "Total",
    "NO_PRODUCTS_SELECTED": "No products selected",
    "PLACE_ORDER": "Place in shopping cart",
    "TECHNICAL_DRAWING": "Technical drawing",
    "TECHNICAL_DRAWINGS": "Technical drawings",
    "TOTAL_AMOUNT": "Total amount",
    "NO_PRODUCTS_FOUND": "No products found",
    "TAB_DOCUMENTS": "Documents",
    "SEARCH_IN_PRORAIL_DATABASE": "Search in ProRail database",
    "PRORAIL_CHOICE": "ProRail choice",
    "TAB_PRODUCT": "Product",
    "TAB_QUESTIONS": "Questions",
    "OUT_OF_STOCK": "Out of stock",
    "IN_STOCK": "In stock, available immediately",
    "IN_STOCK_CACHE": "In stock, available within x days",
    "QUESTIONS_LABEL": "Options",
    "REMOVE": "Remove",
    "UPDATE": "Update",
    "ADD": "Add",
    "NEXT": "Next",
    "CUSTOM_VALUE": "Custom value",
    "CLOSE": "Close",
    "Q_MATERIAL": "Material",
    "Q_SWITCH_HEATING": "Points Heating",
    "Q_SWITCH_OPERATION": "Operation of Turnout",
    "Q_CHAIRS_AND_TAPE_END": "Slide Plate and Stud",
    "Q_LEFT_RIGHT": "Direction Left / Right",
    "Q_LUBRICANT_FREE_CONSTRUCTION": "Turnout Flangeway Clearance Device",
    "Q_POINT_BLADE_MATERIAL": "Frog Material",
    "Q_CROSS_BLADE_MATERIAL": "Obtuse Crossing Material",
    "Q_STRIKE_RULE_MATERIAL": "Check Rail Material",
    "L_LEG_LEFT": "Left leg",
    "L_LEG_RIGHT": "Right leg",
    "L_LEG_LEFT_OUTSIDE": "Left outside",
    "L_LEG_LEFT_INSIDE": "Left inside",
    "L_LEG_RIGHT_INSIDE": "Right inside",
    "L_LEG_RIGHT_OUTSIDE": "Right outside",
    "L_HEATING_PREPARED": "Turnout heating prepared",
    "L_HEATING_CENTRAL": "Central pipe heating",
    "L_LOW": "Low",
    "L_HIGH": "High",
    "L_CHAIRS_NONE": "None",
    "L_CHAIRS_CONCRETE_SLEEPERS": "On concrete sleepers",
    "L_CHAIRS_WOOD_SLEEPERS": "On wooden sleepers",
    "L_CHAIRS_CONCRETE_SLEEPERS_TAPE": "On concrete sleepers and tape end for NSE, VHO, EHO and LPM",
    "L_CHAIRS_SLIDING_EBI": "Slide plate and slide chair for use with EBI",
    "L_CHAIRS_WOOD_SLEEPERS_TAPE": "On wooden sleepers and tape end for NSE-2, VHO, EHO and LPM",
    "L_CHAIRS_SLIDING_EBI_TAPE": "Slide plate and slide chair for use with EBI and tape end",
    "L_CHAIRS_TAPE": "Tape end for NSE, VHO, EHO and LPM",
    // "L_CHAIRS_HEATING_CONCRETE_SLEEPERS_TAPE": "Central pipe heating on concrete sleepers and tape end for NSE, VHO, EHO and LPM",
    "L_CHAIRS_TAPE_EBI": "Tape end for EBI",
    // "L_CHAIRS_HEATING_SLIDING_EBI_TAPE": "Central pipe heating slide plate and slide chair for use with EBI and tape end",
    "L_OPERATION_EBI": "EBI-Switch",
    "L_OPERATION_OTHER": "Other",
    "L_LUBRICANT_FREE_AUSTROROLL": "Austroroll",
    "L_LUBRICANT_FREE_DELTA_SWITCH": "Delta-Switch",
    "L_LUBRICANT_FREE_EKOS": "EKOS/None",
    "LOADING": "Loading...",
    "SEARCH_RESULTS": "Search results",
    "SEARCH_RESULTS_DISCLAIMER": "The ProRail database may contain inaccuracies or incomplete data. Always check if the output is correct.",
    "SEARCH_INPUT": "Search input",
    "SEARCH": "Search",
    "MAT_DESC_0": "Collar bolt NS flat and pure round under the head",
    "MAT_DESC_1": "Clamping bolt M22 x 70 mm with commercial nut",
    "MAT_DESC_2": "Square bolt M22 x 80 mm with nut",
    "MAT_DESC_3": "Clamping plate",
    "MAT_DESC_4": "Spring washer, domed",
    "MAT_DESC_5": "Spring washer",
    "MAT_DESC_6": "Filler plate",
    "MAT_DESC_7": "Rail plate SSp 4",
    "MAT_DESC_8": "Lock washer 23-St-DIN-6916",
    "MAT_DESC_9": "Clamping plate beveled",
    "MAT_DESC_10": "Set of abnormal clamping plates",
    "MAT_DESC_11": "Filler plate between strikebar and chair for strikebar",
    "MAT_DESC_12": "Filler plate between strikebar and chair",
    "MAT_DESC_13": "Set of flat back plates under tongue movement 54E1 1:9",
    "MAT_DESC_14": "Chair for strikebar 54E1",
    "MAT_DESC_15": "Cast flat back plate 54E1",
    "MAT_DESC_16": "Flat welded back plate 54E1 for adhesive welding",
    "MAT_DESC_17": "Set of flat back plates",
    "MAT_DESC_18": "Flat back plate 54E1 cast",
    "MAT_DESC_19": "Flat back plate 54E1 beveled shortened Left",
    "MAT_DESC_20": "Chair 54E1 for strikebar, Left",
    "MAT_DESC_21": "Chair 54E1 for strikebar, Right",
    "MAT_DESC_22": "Back plate (E1) parallel shortened L",
    "MAT_DESC_23": "Back plate (E2) parallel shortened L",
    "MAT_DESC_24": "Set back plates I and VII at location of crossing",
    "MAT_DESC_25": "Flat welded back plate, shortened left",
    "MAT_DESC_26": "Flat welded back plate, shortened right",
    "MAT_DESC_27": "Set back plates I, II, IX and X at location of crossing",
    "MAT_DESC_28": "Set back plates XI, XII, XIX and XX at location of crossing",
    "MAT_DESC_29": "Baseplate",
    "MAT_DESC_30": "Baseplate under back plate",
    "MAT_DESC_31": "Baseplate under slide chair",
    "MAT_DESC_32": "Set of baseplates",
    "MAT_DESC_33": "Set of baseplates under and behind tongue movement",
    "MAT_DESC_34": "Baseplate under welded back plate",
    "MAT_DESC_35": "Set of baseplates under slide chair",
    "MAT_DESC_36": "Set of baseplates under back plate 54E1",
    "MAT_DESC_37": "Baseplate under welded back plate 18-027",
    "MAT_DESC_38": "Baseplate under chair for strikebar",
    "MAT_DESC_39": "Baseplate under crossing 1:4.5",
    "MAT_DESC_40": "Baseplate under 65-245",
    "MAT_DESC_41": "Baseplate for flat back plate E1/E2",
    "MAT_DESC_42": "Baseplate under beveled shortened slide chair",
    "MAT_DESC_43": "Set of cork rubber plates (10) FC897",
    "MAT_DESC_44": "Baseplate under flat back plate",
    "MAT_DESC_45": "Baseplate under parallel shortened flat welded back plate 54E1, 15-203/204",
    "MAT_DESC_46": "Set of baseplates under back plates I to X",
    "MAT_DESC_47": "Set of baseplates under back plates XI to XX",
    "SMEERLOOS_DESC_0": "Toolkit DeltaSwitch",
    "SMEERLOOS_DESC_1": "Parts set, for assembly DeltaSwitch",
    "SMEERLOOS_DESC_2": "DeltaSwitch, high switch blade profile",
    "WISSELSTELLER_DESC_0": "Point machine WBN, NSE-S, Left",
    "WISSELSTELLER_DESC_1": "Point machine WBN, NSE-S, Right",
    "WISSELSTELLER_DESC_2": "Point machine WBN, NSE-S, HL, Left",
    "WISSELSTELLER_DESC_3": "Point machine WBN, NSE-S, HL, Right",
    "WISSELSTELLER_DESC_4": "Point machine WBN, NSE, Left",
    "WISSELSTELLER_DESC_5": "Point machine WBN, NSE, Right",
    "WISSELSTELLER_DIRECTION_0": "Left",
    "WISSELSTELLER_DIRECTION_1": "Right",
    "Q_SWITCH_ACTUATOR_DIRECTION": "Indicate the point machine position",
    "DROPDOWN_EMPTY": "No results",
    "URL_PREFIX": "en_GB",
    "SELECT_LANGUAGE": "Select language",
    "LOGIN_MESSAGE": "Login/Register to see the price and delivery time.",
    "PRORAIL_ANSWER": ({ term }) => `Pre-filled ProRail answer: ${term}`,
    "PRORAIL_ANSWER_UNKNOWN": "No recommended value available in the ProRail database",
    "CATEGORY": "Category",
    "NEXT_BUTTON": "Next",
    "PREV_BUTTON": "Previous",
    "FINISH_BUTTON": "Finish",
    "PLACING_ORDER": "Placing order",
    "PLEASE_WAIT_WHILE_WE_PLACE_YOUR_ORDER": "Please wait while we place your order...",
    "PLEASE_WAIT_WHILE_WE_DOWNLOAD_YOUR_PDF": "Please wait while we prepare your PDF...",
    "SHARE_CONFIGURATION": "Share your configuration",
    "COPY": "Copy",
    "COPIED": "Copied!",
    "COMPLETE_YOUR_CONFIGURATION": "Complete your configuration",
    "DOWNLOAD_PDF": "Download PDF",
    "SELECT_ANOTHER_PART": "Select another switch part",
    "SELECT_A_PART": "Select a switch part",
    "EXTRA_SERVICES": "Extra services",
    "MOBILE_TRACK_SERVICE": "Mobile Track Service",
    "MOBILE_TRACK_SERVICE_DESCRIPTION": "We will contact you with a suitable offer for Mobile Track Service support from voestalpine Turnout Technology Netherlands B.V.",
    "RETURN_OLD_PRODUCT": "Return old product?",
    "RETURN_OLD_PRODUCT_DESCRIPTION": "We handle the collection and circular processing of your replaced track materials in accordance with applicable environmental requirements and will contact you regarding the logistics.",
    "MY_OVERVIEW": "My overview",
    "SUBTOTAL": ({ count }) => `Subtotal (${count} items)`,
    "NEED_HELP": "Need help?",
    "NEED_HELP_DESCRIPTION": "We are ready to validate your specifications.",
    "ONDERLEGSET_WARNING_TITLE": "Warning: You are removing a mandatory safety component",
    "ONDERLEGSET_WARNING_BODY_1": "This asset requires mandatory baseplates in accordance with applicable ProRail guidelines (SPC/BID). These components are an integral part of the prescribed safety and service-life performance of the product.",
    "ONDERLEGSET_WARNING_BODY_2": "Failure to replace or apply these baseplates may negatively affect the service life and performance of the new product.",
    "ONDERLEGSET_WARNING_CHECKBOX": "I declare that I have read and understood the safety information.",
    "KEEP_PRODUCT": "Keep product",
    "ONDERLEG_NOTE": "This asset requires mandatory baseplates in accordance with applicable ProRail guidelines (SPC/BID).",
    "PRODUCT_ADDED": "Product added",
    "CONTINUE_CONFIGURING": "Continue configuring",
    "NRG_LAS_CONFIGURATOR_TITLE": "NRG welding configurator",
    "NRG_LAS_CONFIGURATOR_MESSAGE": "The NRG welding can be configured in our online configurator. Do you want to open the configurator in a new tab?",
    "R260MN_WELDED": "Manganese steel with welded legs R260Mn",
};
const de = {
    "EXACT_MATCH": "Exakte Übereinstimmung auf",
    "tekeningnummer": "Zeichnungsnummer",
    "key": "Schlüssel",
    "geocode": "Geocode",
    "MN": "Mangansstahl",
    "HT": "Hochwertiger Stahl",
    "CURRENCY_LOCALE": "de-DE",
    "ANGLE": "Winkel",
    "LEFT": "Links",
    "RIGHT": "Rechts",
    "SYMETRIC": "Symmetrisch",
    "NORMAL_SWITCH": "Einfache Weiche",
    "NORMAL_SWITCH:ANGLE=LEFT": "Einfache Weiche Links",
    "NORMAL_SWITCH:ANGLE=RIGHT": "Einfache Weiche Rechts",
    "SYMMETRIC_SWITCH": "Symmetrische Weiche",
    "INTERSECTION_SWITCH": "Kreuzungsweiche",
    "ENGLISH_SWITCH": "Kreuzungsweiche",
    "HALF_ENGLISH_SWITCH": "Einfache Kreuzungsweiche",
    "CONCRETE": "Beton",
    "WOOD": "Holz",
    "WOOD_DESCRIPTION": "Weichenschwelle von Holz sind nicht im Konfigurator verfügbar. Bitte kontaktieren Sie uns bei Bedarf.",
    "CONTACT_US": "Kontaktieren Sie uns",
    "CONTINUE_CONFIGURATION": "Konfiguration fortsetzen",
    "CONTINUE_CONFIGURATION_DESCRIPTION": "Wir haben eine vorherige Konfiguration gefunden. Möchten Sie diese fortsetzen oder eine neue Konfiguration starten?",
    "CONFIGURE_NEW": "Neue Konfiguration",
    "CONFIGURE_EDIT": "Fortsetzen",
    "NOT_POSSIBLE_DESCRIPTION": "Diese Option ist nicht möglich in Kombination mit der/den vorherigen Auswahl(en).",
    "NOT_POSSIBLE_CHANGE_TO": ({ tab, values }) => { const v = values.split("||"); const list = v.length > 1 ? v.slice(0, -1).join(", ") + " oder " + v.at(-1) : v[0]; return `Diese Option ist mit der aktuellen ${tab} nicht möglich. Ändern Sie ${tab} auf ${list}, um diese Option auszuwählen.`; },
    "PRODUCT_NOT_POSSIBLE_CONTACT_US": "Dieses Produkt ist in der aktuellen Konfiguration nicht möglich. Bitte kontaktieren Sie uns für weitere Informationen.",
    "GO_TO_TAB": ({ tab }) => `Zur Auswahl gehen: ${tab}`,
    "PRODUCT_DETAILS_TITLE": "Produktinformation",
    "NEXT_STEP": "Nächster Schritt",
    "halveTongbewegingen": "Halbe Zungenvorrichtungen",
    "halveTongbeweging": "Halbe Zungenvorrichtung",
    "puntstukken": "Herzstücke",
    "puntstuk": "Herzstück",
    "kruisstukken": "Doppelte Herzstücke",
    "kruisstuk": "Doppeltes Herzstück",
    "strijkregels": "Führungsschienen",
    "strijkregel": "Führungsschiene",
    "onderlegplaten": "Unterlagsplatten",
    "onderlegplaat": "Unterlagsplatte",
    "rugplatenEnStoelen": "Rippenplatten und Gleitplatten",
    "rugplaatEnStoel": "Rippenplatte und Gleitplatte",
    "bevestigingsmaterialen": "Befestigungselemente",
    "bevestigingsmiddelen": "Befestigungselemente",
    "bevestigingsmiddel": "Befestigungselement",
    "wisselstellers": "Weichenstellvorrichtung",
    "wisselsteller": "Weichenstellvorrichtung",
    "smeerlozeConstructies": "Rollensysteme",
    "smeerlozeConstructie": "Rollensystem",
    "nrglassen": "Elektrischer Trennstoß - NRG-Trennstoß",
    "nrglas": "Elektrischer Trennstoß - NRG-Trennstoß",
    "VARIANT_CHANGED_TITLE": "Eine Produktvariante hat sich geändert",
    "VARIANT_CHANGED_DESCRIPTION": ({ cat }) => `Die Variante von ${cat} hat sich geändert`,
    "FROM": "Von",
    "TO": "Zu",
    "BEKIJK_PRODUCT": "Produkt anzeigen",
    "ok": "Verstanden",
    "ADD_PRODUCTS": "Weitere Produkte hinzufügen",
    "ADD_PRODUCTS_DESCRIPTION": "Sie können weitere Produkte zu Ihrer Liste hinzufügen, wie z.B. Befestigungsmaterialien.",
    "NOT_AVAILABLE_SHORT": "nicht verfügbar",
    "WILL_OVERRIDE_CONFIGURATION": "Dies überschreibt die aktuelle Konfiguration.",
    "NO_CANCEL": "Nein, abbrechen",
    "YES_APPLY": "Ja, anwenden",
    "YES_CONTINUE": "Ja, fortfahren",
    "NO_RESULTS_FOUND": "Keine Ergebnisse gefunden",
    "RECENT_SEARCHES": "Zuletzt angesehen",
    "NO_RECENT_SEARCHES": "Keine zuletzt angesehenen Weichen",
    "REMOVE_FROM_RECENT": "Aus zuletzt angesehen entfernen",
    "SWITCH_TYPE": "Weichentyp",
    "SLEEPER_TYPE": "Schwellentyp",
    "ANGLE_RATIO": "Weichenwinkel",
    "RAIL_PROFILE": "Schienenprofil",
    "RADIUS": "Bogenradius",
    "GEOCODE": "Geocode",
    "LUBRICANT_FREE_CONSTRUCTION": "Rollensysteme",
    "AFSCHRIJVINGSGROEP_TODO": "Abschreibungsgruppe",
    "CLASSIFICATION": "Klassifikation",
    "PLACEMENT_DATE": "Einbaudatum",
    "DRAWING_NUMBER": "Zeichnungsnummer",
    "SELECTED_SWITCH_CONFIGURATION": "Ausgewählte Weichenkonfiguration",
    "NOT_AVAILABLE": "Diese Weiche/Kreuzung ist im Konfigurator nicht verfügbar.",
    "CROSSING": "Kreuzung",
    "SWITCH": "Weiche",
    "APPLY_THIS": ({ type }) => `Möchten Sie diese ${type} anwenden?`,
    "NOTIFY_PRORAIL_ISSUE": "Feedback geben",
    "DESCRIBE_ERROR_HERE": "Beschreiben Sie hier den Fehler",
    "CANCEL_BUTTON": "Abbrechen",
    "SEND_EMAIL": "E-Mail senden",
    "PARTS_LIST_TITLE": "Meine Liste",
    "CONFIGURATION": "Konfiguration:",
    "SEARCH_RESULTS_FOR": ({ term }) => `Suchergebnisse für "${term}"`,
    "PDF_SWITCH_PARTS_CONFIGURATOR": "Weichenteil-Konfigurator",
    "VOESTALPINE_RAILWAY_SYSTEMS": "voestalpine Railway Systems",
    "VOESTALPINE_WEBSITE": "www.voestalpine.com/railway-systems",
    "ARTICLE_NUMBER": "Artikelnummer",
    "RELATED_PARTS": "Verwandte Teile",
    "TAB_SPECIFICATIONS": "Spezifikationen",
    "CHARACTERISTIC": "Merkmal",
    "SPECIFICATION": "Spezifikation",
    "NO_SPECIFICATIONS_AVAILABLE": "Keine Spezifikationen verfügbar",
    "PDF_FILE_NAME": "Weichenkonfiguration",
    "CONFIGURATION_WILL_BE_DELETED": "Dies löscht die gesamte Konfiguration.",
    "CONFIGURATION_NUMBER": "[Konfigurationsnummer]",
    "CONFIRM_DELETE": "Bist du sicher?",
    "NO_DELETE": "Nein, abbrechen",
    "YES_RESET": "Ja, zurücksetzen",
    "YES_DELETE": "Ja, löschen",
    "REMOVE_ARTICLE": "Willst du diesen Artikel aus der Konfiguration entfernen?",
    "RESET_BUTTON": "Zurücksetzen",
    "PARTS_LIST_BTN": "Teilliste",
    "INCOMPLETE_INFO_TITLE": "Unvollständige Informationen",
    "ANSWER_ALL_QUESTIONS": "Beantworten Sie alle Fragen, um das Produkt anzuzeigen.",
    "PARTS_LIST_UPDATED": "Teilliste wurde aktualisiert",
    "EXC_VAT": "exkl. MwSt.",
    "SAVE_CONFIGURATION": "Konfiguration speichern",
    "PARTS_COMPOSITION": "Weichenteilzusammensetzung:",
    "DESCRIPTION": "Beschreibung",
    "QUANTITY": "Menge",
    "PRODUCT_CODE": "Produktcode",
    "TOTAL_AMOUNT_EXC_VAT": "Gesamtbetrag exkl. MwSt.",
    "TOTAL": "Gesamt",
    "NO_PRODUCTS_SELECTED": "Keine Produkte ausgewählt",
    "PLACE_ORDER": "Bestellung aufgeben",
    "TECHNICAL_DRAWING": "Technische Zeichnung",
    "TECHNICAL_DRAWINGS": "Technische Zeichnungen",
    "TOTAL_AMOUNT": "Gesamtbetrag",
    "NO_PRODUCTS_FOUND": "Keine Produkte gefunden",
    "TAB_DOCUMENTS": "Dokumente",
    "SEARCH_IN_PRORAIL_DATABASE": "In ProRail-Datenbank suchen",
    "PRORAIL_CHOICE": "ProRail-Auswahl",
    "TAB_PRODUCT": "Produkt",
    "TAB_QUESTIONS": "Fragen",
    "OUT_OF_STOCK": "Nicht auf Lager",
    "QUESTIONS_LABEL": "Optionen",
    "REMOVE": "Entfernen",
    "UPDATE": "Aktualisieren",
    "ADD": "Hinzufügen",
    "NEXT": "Weiter",
    "IN_STOCK": "Auf Lager, sofort lieferbar",
    "IN_STOCK_CACHE": "Auf Lager, lieferbar innerhalb von x Tagen",
    "CUSTOM_VALUE": "Benutzerdefinierter Wert",
    "CLOSE": "Schließen",
    "Q_MATERIAL": "Material",
    "Q_SWITCH_HEATING": "Weichenerwärmung",
    "Q_SWITCH_OPERATION": "Weichenbetätigung",
    "Q_CHAIRS_AND_TAPE_END": "Stühle und Bandende",
    "Q_LEFT_RIGHT": "Richtung Links / Rechts",
    "Q_LUBRICANT_FREE_CONSTRUCTION": "Rollensysteme",
    "Q_POINT_BLADE_MATERIAL": "Herzstückmaterial",
    "Q_CROSS_BLADE_MATERIAL": "Doppelherzstückmaterial",
    "Q_STRIKE_RULE_MATERIAL": "Führungsschienematerial",
    "L_LEG_LEFT": "Linkes Bein",
    "L_LEG_RIGHT": "Rechtes Bein",
    "L_LEG_LEFT_OUTSIDE": "Außen links",
    "L_LEG_LEFT_INSIDE": "Innen links",
    "L_LEG_RIGHT_INSIDE": "Innen rechts",
    "L_LEG_RIGHT_OUTSIDE": "Außen rechts",
    "L_HEATING_PREPARED": "Weichenheizung vorbereitet",
    "L_HEATING_CENTRAL": "Zentrale Weichenheizung",
    "L_LOW": "Niedrig",
    "L_HIGH": "Hoch",
    "L_CHAIRS_NONE": "Keine",
    "L_CHAIRS_CONCRETE_SLEEPERS": "Auf Betonschwellen",
    "L_CHAIRS_WOOD_SLEEPERS": "Auf Holzschwellen",
    "L_CHAIRS_CONCRETE_SLEEPERS_TAPE": "Auf Betonschwellen und Bandende für NSE, VHO, EHO und LPM",
    "L_CHAIRS_SLIDING_EBI": "Gleitplatte und Gleitstühle für EBI-Anwendungen",
    "L_CHAIRS_WOOD_SLEEPERS_TAPE": "Auf Holzschwellen und Bandende für NSE-2, VHO, EHO und LPM",
    "L_CHAIRS_SLIDING_EBI_TAPE": "Gleitplatte und Gleitstühle für EBI-Anwendungen und Bandende",
    "L_CHAIRS_TAPE": "Bandende für NSE, VHO, EHO und LPM",
    // "L_CHAIRS_HEATING_CONCRETE_SLEEPERS_TAPE": "Zentrale Weichenheizung auf Betonschwellen und Bandende für NSE, VHO, EHO und LPM",
    "L_CHAIRS_TAPE_EBI": "Bandende für EBI",
    // "L_CHAIRS_HEATING_SLIDING_EBI_TAPE": "Zentrale Weichenheizung Gleitplatte und Gleitstühle für EBI-Anwendungen und Bandende",
    "L_OPERATION_EBI": "EBI-Weiche",
    "L_OPERATION_OTHER": "Sonstiges",
    "L_LUBRICANT_FREE_AUSTROROLL": "Austroroll",
    "L_LUBRICANT_FREE_DELTA_SWITCH": "Delta-Switch",
    "L_LUBRICANT_FREE_EKOS": "EKOS/Keine",
    "LOADING": "Wird geladen...",
    "SEARCH_RESULTS": "Suchergebnisse",
    "SEARCH_RESULTS_DISCLAIMER": "Die ProRail-Datenbank kann Ungenauigkeiten enthalten. Überprüfen Sie immer, ob die Daten korrekt sind.",
    "SEARCH_INPUT": "Eingabe suchen",
    "SEARCH": "Suchen",
    "MAT_DESC_0": "Kragenbolzen NS flach und rein rund unter dem Kopf",
    "MAT_DESC_1": "Klemschraube M22 x 70 mm mit Handelsmutter",
    "MAT_DESC_2": "Vierkantschraube M22 x 80 mm mit Mutter",
    "MAT_DESC_3": "Klemplatte",
    "MAT_DESC_4": "Tellerfeder, gewölbt",
    "MAT_DESC_5": "Tellerfeder",
    "MAT_DESC_6": "Füllplatte",
    "MAT_DESC_7": "Schienenplatte SSp 4",
    "MAT_DESC_8": "Sicherungsscheibe 23-St-DIN-6916",
    "MAT_DESC_9": "Klemplatte gekielt",
    "MAT_DESC_10": "Satz abnormale Klemplatten",
    "MAT_DESC_11": "Füllplatte zwischen Streichschiene und Stuhl für Streichschiene",
    "MAT_DESC_12": "Füllplatte zwischen Streichschiene und Stuhl",
    "MAT_DESC_13": "Satz flache Rückenplatten unter Zungenbewegung 54E1 1:9",
    "MAT_DESC_14": "Stuhl für Streichschiene 54E1",
    "MAT_DESC_15": "Gegossene flache Rückenplatte 54E1",
    "MAT_DESC_16": "Flache geschweißte Rückenplatte 54E1 für Klebeverbindung",
    "MAT_DESC_17": "Satz flache Rückenplatten",
    "MAT_DESC_18": "Flache Rückenplatte 54E1 gegossen",
    "MAT_DESC_19": "Flache Rückenplatte 54E1 schräg gekürzt Links",
    "MAT_DESC_20": "Stuhl 54E1 für Streichschiene, Links",
    "MAT_DESC_21": "Stuhl 54E1 für Streichschiene, Rechts",
    "MAT_DESC_22": "Rückenplatte (E1) parallel gekürzt L",
    "MAT_DESC_23": "Rückenplatte (E2) parallel gekürzt L",
    "MAT_DESC_24": "Satz Rückenplatten I und VII an der Kreuzungsstelle",
    "MAT_DESC_25": "Flache geschweißte Rückenplatte, links gekürzt",
    "MAT_DESC_26": "Flache geschweißte Rückenplatte, rechts gekürzt",
    "MAT_DESC_27": "Satz Rückenplatten I, II, IX und X an der Kreuzungsstelle",
    "MAT_DESC_28": "Satz Rückenplatten XI, XII, XIX und XX an der Kreuzungsstelle",
    "MAT_DESC_29": "Unterlegplatte",
    "MAT_DESC_30": "Unterlegplatte unter Rückenplatte",
    "MAT_DESC_31": "Unterlegplatte unter Gleitstühle",
    "MAT_DESC_32": "Satz Unterlegplatten",
    "MAT_DESC_33": "Satz Unterlegplatten unter und hinter Zungenbewegung",
    "MAT_DESC_34": "Unterlegplatte unter geschweißte Rückenplatte",
    "MAT_DESC_35": "Satz Unterlegplatten unter Gleitstühle",
    "MAT_DESC_36": "Satz Unterlegplatten unter Rückenplatte 54E1",
    "MAT_DESC_37": "Unterlegplatte unter geschweißte Rückenplatte 18-027",
    "MAT_DESC_38": "Unterlegplatte unter Stuhl für Streichschiene",
    "MAT_DESC_39": "Unterlegplatte unter Kreuzung 1:4,5",
    "MAT_DESC_40": "Unterlegplatte unter 65-245",
    "MAT_DESC_41": "Unterlegplatte für flache Rückenplatte E1/E2",
    "MAT_DESC_42": "Unterlegplatte unter schräg gekürzte Gleitstühle",
    "MAT_DESC_43": "Satz Korkgummiplatten (10) FC897",
    "MAT_DESC_44": "Unterlegplatte unter flache Rückenplatte",
    "MAT_DESC_45": "Unterlegplatte unter parallel gekürzte flache geschweißte Rückenplatte 54E1, 15-203/204",
    "MAT_DESC_46": "Satz Unterlegplatten unter Rückenplatten I bis X",
    "MAT_DESC_47": "Satz Unterlegplatten unter Rückenplatten XI bis XX",
    "SMEERLOOS_DESC_0": "Werkzeugkoffer Delta-Switch",
    "SMEERLOOS_DESC_1": "Ersatzteilsatz, Montageanleitung Delta-Switch",
    "SMEERLOOS_DESC_2": "Delta-Switch, hohes Zungenprofil",
    "WISSELSTELLER_DESC_0": "Weichensteller WBN, NSE-S, Links",
    "WISSELSTELLER_DESC_1": "Weichensteller WBN, NSE-S, Rechts",
    "WISSELSTELLER_DESC_2": "Weichensteller WBN, NSE-S, HL, Links",
    "WISSELSTELLER_DESC_3": "Weichensteller WBN, NSE-S, HL, Rechts",
    "WISSELSTELLER_DESC_4": "Weichensteller WBN, NSE, Links",
    "WISSELSTELLER_DESC_5": "Weichensteller WBN, NSE, Rechts",
    "WISSELSTELLER_DIRECTION_0": "Links",
    "WISSELSTELLER_DIRECTION_1": "Rechts",
    "Q_SWITCH_ACTUATOR_DIRECTION": "Geben Sie die Position des Weichenstellers an",
    "DROPDOWN_EMPTY": "Keine Ergebnisse",
    "URL_PREFIX": "de_DE",
    "SELECT_LANGUAGE": "Sprache auswählen",
    "LOGIN_MESSAGE": "Melden Sie sich an, um den Preis und die Lieferzeit zu sehen.",
    "PRORAIL_ANSWER": ({ term }) => `Vorab ausgefüllte ProRail-Antwort: ${term}`,
    "PRORAIL_ANSWER_UNKNOWN": "Kein empfohlener Wert in der ProRail-Datenbank verfügbar",
    "CATEGORY": "Kategorie",
    "NEXT_BUTTON": "Weiter",
    "PREV_BUTTON": "Zurück",
    "FINISH_BUTTON": "Fertig",
    "PLACING_ORDER": "Bestellung aufgeben",
    "PLEASE_WAIT_WHILE_WE_PLACE_YOUR_ORDER": "Bitte warten Sie, während wir Ihre Bestellung aufgeben...",
    "PLEASE_WAIT_WHILE_WE_DOWNLOAD_YOUR_PDF": "Bitte warten Sie, während wir Ihr PDF vorbereiten...",
    "SHARE_CONFIGURATION": "Konfiguration teilen",
    "COPY": "Kopieren",
    "COPIED": "Kopiert!",
    "COMPLETE_YOUR_CONFIGURATION": "Vervollständigen Sie Ihre Konfiguration",
    "DOWNLOAD_PDF": "PDF herunterladen",
    "SELECT_ANOTHER_PART": "Weiteres Weichenteil auswählen",
    "SELECT_A_PART": "Ein Weichenteil auswählen",
    "EXTRA_SERVICES": "Zusatzleistungen",
    "MOBILE_TRACK_SERVICE": "Mobiler Gleisservice",
    "MOBILE_TRACK_SERVICE_DESCRIPTION": "Wir werden uns mit einem passenden Angebot für die Unterstützung des Mobilen Gleisservices von voestalpine Turnout Technology Netherlands B.V. bei Ihnen melden.",
    "RETURN_OLD_PRODUCT": "Altes Produkt zurücksenden?",
    "RETURN_OLD_PRODUCT_DESCRIPTION": "Wir kümmern uns um die Rücknahme und zirkuläre Verarbeitung Ihrer ausgetauschten Gleismaterialien gemäß den geltenden Umweltanforderungen und werden uns für die logistische Abwicklung mit Ihnen in Verbindung setzen.",
    "MY_OVERVIEW": "Meine Übersicht",
    "SUBTOTAL": ({ count }) => `Zwischensumme (${count} Artikel)`,
    "NEED_HELP": "Hilfe benötigt?",
    "NEED_HELP_DESCRIPTION": "Wir stehen bereit, Ihre Spezifikationen zu validieren.",
    "ONDERLEGSET_WARNING_TITLE": "Achtung: Sie entfernen ein vorgeschriebenes Sicherheitsbauteil",
    "ONDERLEGSET_WARNING_BODY_1": "Zu diesem Asset gehören vorgeschriebene Unterlagsplatten gemäß den geltenden ProRail-Richtlinien (SPC/BID). Diese Bauteile sind integraler Bestandteil der vorgeschriebenen Sicherheits- und Lebensdauerleistung des Produkts.",
    "ONDERLEGSET_WARNING_BODY_2": "Das Nichtaustauschen oder Nichtanwenden dieser Unterlagsplatten kann die Lebensdauer und Funktion des neuen Produkts negativ beeinflussen.",
    "ONDERLEGSET_WARNING_CHECKBOX": "Ich erkläre, dass ich die Sicherheitsinformationen gelesen habe und diese verstehe.",
    "KEEP_PRODUCT": "Produkt behalten",
    "ONDERLEG_NOTE": "Zu diesem Asset gehören vorgeschriebene Unterlagsplatten gemäß den geltenden ProRail-Richtlinien (SPC/BID).",
    "PRODUCT_ADDED": "Produkt hinzugefügt",
    "CONTINUE_CONFIGURING": "Weiter konfigurieren",
    "NRG_LAS_CONFIGURATOR_TITLE": "NRG-Schweißkonfigurator",
    "NRG_LAS_CONFIGURATOR_MESSAGE": "Die NRG-Schweißung kann in unserem Online-Konfigurator konfiguriert werden. Möchten Sie den Konfigurator in einem neuen Tab öffnen?",
    "R260MN_WELDED": "Manganstahl mit geschweißten Beinen R260Mn",
};
export const languages = { nl, en, de };
let langCached;
const getLanguage = () => {
    const href = location.href;
    if (langCached?.href === href)
        return langCached.lang;
    const url = new URL(href);
    let lang = url.searchParams.get("lang");
    if (lang && lang in languages) {
        langCached = { href, lang: lang };
        return lang;
    }
    lang = url.pathname.split("/")?.[1]?.split("_")?.[0];
    if (lang && lang in languages) {
        langCached = { href, lang: lang };
        return lang;
    }
    langCached = { href, lang: "nl" };
    return "nl";
};
const URL_PREFIX_OVERRIDES = {
    "railway-systems-shop.voestalpine.com": { nl: "nl_BE" },
};
export const getUrlPrefix = (language = getLanguage()) => {
    const host = location.hostname.replace(/^www\./, "");
    return URL_PREFIX_OVERRIDES[host]?.[language] ?? getTextFixed("URL_PREFIX", undefined, undefined, language);
};
export const getTextFixed = (key, args, fallback, language = getLanguage()) => getText(key, args, fallback, language);
export const getKey = (text, candidates) => {
    if (text == undefined || text === "")
        return;
    if (candidates.includes(text))
        return text;
    for (const lang of Object.keys(languages))
        for (const candidate of candidates)
            if (getText(candidate, undefined, undefined, lang) === text)
                return candidate;
    return;
};
export const getText = (key, args, fallback, language = getLanguage()) => {
    if (!key)
        return;
    key = typeof key === "function" ? key() : key;
    const dict = languages[language];
    let text = dict?.[key] ?? shared[key];
    if (!text)
        return (typeof fallback === "function" ? fallback() : fallback) ?? `NO TRANSLATION FOUND FOR KEY "${key}"`;
    try {
        if (typeof text === "function")
            return text(args ?? {});
        if (args) {
            args = typeof args === "function" ? args() : args;
            return text.replace(/{{(.*?)}}/g, (_, v) => String(args?.[v] ?? `NO VARIABLE FOUND FOR KEY "${key}" AND VAR ${v}`));
        }
        return text;
    }
    catch (e) {
        console.error(`Error processing text for key "${key}" with args ${JSON.stringify(args)}:`, e);
        return fallback ?? `ERROR PROCESSING TEXT FOR KEY "${key}"`;
    }
};
